import React, { useContext, useMemo } from "react";
import { NavLink } from "react-router-dom";
import classes from "./Service.module.css";
import { ReactComponent as Dots } from "../../assets/vector/dots.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectCards } from "swiper";

import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/autoplay";
import "swiper/css/pagination";

import { mouseContext } from "../../context/mouseContext";

const Service = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(mouseContext);

  const services = useMemo(
    () => [
      { title: "Web Development", count: "01" },
      { title: "App Development", count: "02" },
      { title: "Digital Marketing", count: "03" },
      { title: "Blockchain Development", count: "04" },
      { title: "Creative Design", count: "05" },
    ],
    []
  );

  return (
    <section className={classes.section} aria-labelledby="services-heading">
      <div className="section-title">
        <h1 id="services-heading" className="section-heading">
          Our Services
        </h1>
        <h5 className="section-subheading">WHAT WE PROVIDE</h5>
      </div>

      <div className={classes["service-info"]}>
        <Dots className={classes.dots1} />

        <Swiper
          modules={[EffectCards, Pagination, Autoplay]}
          effect="cards"
          autoplay={{ delay: 1400, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          grabCursor
          className={classes.swiper}
          aria-roledescription="carousel"
        >
          {services.map((service, index) => (
            <SwiperSlide
              key={service.count}
              className={classes["swiper-slide"]}
              onMouseEnter={mouseEnterHandler}
              onMouseLeave={mouseLeaveHandler}
            >
              <h2 aria-hidden="true">{service.count}</h2>
              <h1>{service.title}</h1>
            </SwiperSlide>
          ))}
        </Swiper>

        <Dots className={classes.dots2} />

        <NavLink
          to="/services"
          className={classes["view-more"]}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          aria-label="View all services offered by IQApex Labs"
        >
          View All Services
        </NavLink>
      </div>
    </section>
  );
};

export default Service;
